import { render } from "./DatasetSelection.vue?vue&type=template&id=137c2ab8"
import script from "./DatasetSelection.vue?vue&type=script&lang=js"
export * from "./DatasetSelection.vue?vue&type=script&lang=js"

import "./DatasetSelection.vue?vue&type=style&index=0&id=137c2ab8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__